import React from 'react';
import PropTypes from 'prop-types';

import ExternalLink from 'components/Widgets/ExternalLink';

import routes from 'app/routes';

import { useContext as useUsersContext } from 'components/Users/Context';

export default function TotalRow({ cycle }) {
  const { state: stateUsers } = useUsersContext();

  const member = stateUsers.user.attributes.specific;

  return (
    <div className="d-flex justify-content-end mt-2">
      <ExternalLink
        href={routes.api.member_benefit_payments.report(
          member.id,
          cycle.id,
        )}
      >
        Download PDF
      </ExternalLink>
    </div>
  );
}

TotalRow.propTypes = {
  cycle: PropTypes.object.isRequired,
};
